import { call, put, takeLatest } from 'redux-saga/effects';
import { generateDemoSubmit } from 'api/DemoDataAPI';
import { uploadEventURL } from 'api/PublicIterableAPI';
import type { ApiError, ApiResponse } from 'services/api';
import { addPositiveToast, addNegativeToast } from 'modules/toastContainer';
import { addToRootSaga } from 'store';
import * as actions from './actions';
import * as actionTypes from './actionTypes';

/**
 * generateDemoAccountRequest
 * Saga for generating new demo data account
 */
export function* generateDemoAccountRequest({
  email,
  projectName,
}: ReturnType<typeof actions.generateDemoAccountRequest>) {
  try {
    yield call(generateDemoSubmit, email, projectName);
    yield put(addPositiveToast('Request Accepted, this may take up to 5 Minutes'));
  } catch (error) {
    yield put(addNegativeToast('Something went wrong. Please try again.'));
  }
}

/**
 * uploadEventRequest
 * Saga for posting event and getting response
 */
export function* uploadEventRequest({
  apiKey,
  body,
  endpoint,
}: ReturnType<typeof actions.uploadEventRequest>) {
  try {
    const response: ApiResponse = yield call(uploadEventURL, apiKey, body, endpoint);
    yield put(addPositiveToast(response.data.msg));
    yield put(actions.uploadEventResponse());
  } catch (error) {
    const errorMessage = (error as ApiError).response?.data?.msg || (error as ApiError).message;
    const status = (error as ApiError).response?.status;
    yield put(addNegativeToast(`${status}: ${errorMessage}`));
    yield put(actions.uploadEventResponse());
  }
}

addToRootSaga([
  takeLatest(actionTypes.GENERATE_DEMO_ACCOUNT_REQUEST, generateDemoAccountRequest),
  takeLatest(actionTypes.UPLOAD_EVENT_REQUEST, uploadEventRequest),
]);
